import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon, VerifiedIcon, HomeIcon, ArrowRightIcon } from 'lucide-react';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="pt-20 sm:pt-24 md:pt-32 pb-8 sm:pb-12 md:pb-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-gray-50" aria-label="Hero Canjee" data-id="element-173">
      <div className="max-w-7xl mx-auto" data-id="element-174">
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 items-center" data-id="element-175">
          {/* Columna izquierda: texto y CTAs */}
          <div className="space-y-4 sm:space-y-6 md:space-y-8" data-id="element-176">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" data-id="element-177">
              Con un canje ordenado,{' '}
              <span className="underline decoration-indigo-300" data-id="element-178">
                vendes más
              </span>{' '}
              y sin enredos.
            </h1>
            {/* Descripción breve */}
            <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-179">
              Conecta con otros corredores en una red privada y exclusiva.
              Publica tus propiedades gratis y usa créditos para solicitar
              canjes reales.
            </p>
            {/* Bullets diferenciadores */}
            <div className="space-y-2.5 sm:space-y-3" aria-label="Diferenciadores clave" data-id="element-180">
              <div className="flex items-start space-x-2.5 sm:space-x-3" data-id="element-181">
                <CheckCircle2Icon className="w-5 h-5 sm:w-6 sm:h-6 text-indigo-900 flex-shrink-0 mt-0.5" data-id="element-182" />
                <span className="text-sm sm:text-base text-gray-700" data-id="element-183">
                  Publica propiedades gratis (todos los usuarios)
                </span>
              </div>
              <div className="flex items-start space-x-2.5 sm:space-x-3" data-id="element-184">
                <CheckCircle2Icon className="w-5 h-5 sm:w-6 sm:h-6 text-indigo-900 flex-shrink-0 mt-0.5" data-id="element-185" />
                <span className="text-sm sm:text-base text-gray-700" data-id="element-186">
                  3 créditos mensuales gratis para solicitar canjes
                </span>
              </div>
              <div className="flex items-start space-x-2.5 sm:space-x-3" data-id="element-187">
                <CheckCircle2Icon className="w-5 h-5 sm:w-6 sm:h-6 text-indigo-900 flex-shrink-0 mt-0.5" data-id="element-188" />
                <span className="text-sm sm:text-base text-gray-700" data-id="element-189">
                  Red privada: solo con cuenta activa
                </span>
              </div>
            </div>
            {/* CTAs */}
            <div className="flex flex-col gap-2.5 sm:gap-3 pt-2 sm:pt-4" data-id="element-190">
              <button onClick={() => scrollToSection('unirme')} className="w-full px-5 sm:px-6 md:px-8 py-3 sm:py-3.5 md:py-4 text-sm sm:text-base font-semibold text-white bg-indigo-900 rounded-xl hover:bg-indigo-800 transition-all hover:shadow-xl hover:-translate-y-0.5" aria-label="Únete a la lista de espera" data-id="element-191">
                Únete a la lista de espera
              </button>
              <button onClick={() => scrollToSection('como-funciona')} className="w-full px-5 sm:px-6 md:px-8 py-3 sm:py-3.5 md:py-4 text-sm sm:text-base font-semibold text-indigo-900 bg-white border-2 border-indigo-900 rounded-xl hover:bg-indigo-50 transition-all" aria-label="Conoce cómo funciona" data-id="element-192">
                Conoce cómo funciona
              </button>
            </div>
            {/* Etiquetas de confianza */}
            <div className="flex flex-wrap items-center gap-3 sm:gap-4 md:gap-6 pt-2" data-id="element-193">
              <div className="flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-gray-600" data-id="element-194">
                <ShieldCheckIcon className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-900" data-id="element-195" />
                <span data-id="element-196">Red Privada</span>
              </div>
              <div className="flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-gray-600" data-id="element-197">
                <VerifiedIcon className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-900" data-id="element-198" />
                <span data-id="element-199">Transparencia</span>
              </div>
              <div className="flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm text-gray-600" data-id="element-200">
                <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-indigo-900" data-id="element-201" />
                <span data-id="element-202">Verificación</span>
              </div>
            </div>
          </div>
          {/* Columna derecha: tarjetas animadas */}
          <div className="hidden lg:flex items-center justify-center relative" data-id="element-203">
            <div className="relative w-full max-w-2xl h-[600px]" data-id="element-204">
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/20 to-blue-500/20 rounded-full blur-3xl" data-id="element-205"></div>
              <div className="absolute top-20 left-0 w-80 bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 transform -rotate-6 hover:rotate-0 transition-transform duration-300" data-id="element-206">
                <div className="flex items-center justify-between mb-4" data-id="element-207">
                  <div className="flex items-center gap-2" data-id="element-208">
                    <HomeIcon className="w-5 h-5 text-indigo-900" data-id="element-209" />
                    <span className="text-sm font-semibold text-gray-900" data-id="element-210">
                      Propiedad
                    </span>
                  </div>
                  <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-bold rounded-full" data-id="element-211">
                    Abierto a Canje
                  </span>
                </div>
                <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80" alt="Interior moderno de propiedad" className="aspect-video object-cover rounded-xl mb-4" data-id="element-212" />
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-213">
                  Depto 2D/2B, Las Condes
                </h3>
                <div className="flex items-center justify-between text-sm" data-id="element-214">
                  <span className="text-gray-600" data-id="element-215">UF 5.500</span>
                  <span className="text-indigo-900 font-semibold" data-id="element-216">
                    3% ofrecido
                  </span>
                </div>
              </div>
              <div className="absolute top-32 right-12 w-72 bg-indigo-900 rounded-2xl shadow-2xl p-6 transform rotate-3 hover:rotate-0 transition-transform duration-300 z-10" data-id="element-217">
                <div className="text-center space-y-4" data-id="element-218">
                  <div className="flex items-center justify-center" data-id="element-219">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center" data-id="element-220">
                      <CheckCircle2Icon className="w-10 h-10 text-white" data-id="element-221" />
                    </div>
                  </div>
                  <h3 className="text-white font-bold text-xl" data-id="element-222">
                    ¡Match encontrado!
                  </h3>
                  <p className="text-indigo-200 text-sm" data-id="element-223">
                    María González quiere canjear
                  </p>
                  <div className="bg-white/10 rounded-xl p-3" data-id="element-224">
                    <div className="flex items-center justify-between text-white text-sm" data-id="element-225">
                      <span data-id="element-226">Split propuesto</span>
                      <span className="font-bold" data-id="element-227">50/50</span>
                    </div>
                  </div>
                  <button className="w-full bg-white text-indigo-900 font-semibold py-3 rounded-xl hover:bg-gray-100 transition-colors flex items-center justify-center gap-2" data-id="element-228">
                    Ver propuesta
                    <ArrowRightIcon className="w-4 h-4" data-id="element-229" />
                  </button>
                </div>
              </div>
              <div className="absolute bottom-16 left-12 w-80 bg-white rounded-2xl shadow-2xl border border-gray-200 p-6 transform rotate-2 hover:rotate-0 transition-transform duration-300 z-20" data-id="element-230">
                <div className="space-y-4" data-id="element-231">
                  <div className="flex items-center justify-between" data-id="element-232">
                    <h3 className="font-bold text-gray-900" data-id="element-233">
                      Acuerdo de Canje
                    </h3>
                    <CheckCircle2Icon className="w-6 h-6 text-green-600" data-id="element-234" />
                  </div>
                  <div className="space-y-3 text-sm" data-id="element-235">
                    <div className="flex justify-between" data-id="element-236">
                      <span className="text-gray-600" data-id="element-237">Vendedor:</span>
                      <span className="font-medium text-gray-900" data-id="element-238">
                        Juan Pérez
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-239">
                      <span className="text-gray-600" data-id="element-240">Comprador:</span>
                      <span className="font-medium text-gray-900" data-id="element-241">
                        María González
                      </span>
                    </div>
                    <div className="h-px bg-gray-200" data-id="element-242"></div>
                    <div className="flex justify-between" data-id="element-243">
                      <span className="text-gray-600" data-id="element-244">Split:</span>
                      <span className="font-bold text-indigo-900" data-id="element-245">
                        50% / 50%
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-246">
                      <span className="text-gray-600" data-id="element-247">Vigencia:</span>
                      <span className="font-medium text-gray-900" data-id="element-248">90 días</span>
                    </div>
                  </div>
                  <div className="pt-2" data-id="element-249">
                    <div className="bg-green-50 border border-green-200 rounded-lg p-3" data-id="element-250">
                      <p className="text-green-800 text-sm font-medium text-center" data-id="element-251">
                        ✓ Acuerdo firmado y activo
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}